<template>
    <div
        :class="[
            `bg-${modelClass}`,
            'relative text-text pt-44 pl-13 pb-12 pr-11',
        ]"
    >
        <p
            :class="[
                `text-${modelClass}-accent`,
                'font-header text-4xl md:text-6xl font-semibold  hyphens-auto',
            ]"
            v-text="
                $getBaseModelTranslation({
                    modelName: modelClass,
                    wordClass: 'PLURAL',
                    capitalize: true,
                })
            "
        />
        <p class="text-sm mt-4 max-w-textbody" v-text="description" />
        <ExpandingCreateButton
            v-if="can.create"
            :modelClass="modelClass"
            :text="$lang.get('Create')"
            :url="$localizedRoute(`${modelClass}.create`)"
            class="absolute right-8 top-5"
        />
    </div>
    <!-- Slot for the datatable -->
    <div class="pt-12 pb-20 px-12">
        <slot />
    </div>
</template>

<script>
import ExpandingCreateButton from '@/Components/ModelComponents/ExpandingCreateButton.vue'

export default {
    components: {
        ExpandingCreateButton,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        can: {
            type: Object,
            required: true,
            validator: (value) => {
                return value.hasOwnProperty('create')
            },
        },
    },
}
</script>
